import BaseComponent from "../../../baseComponent.js";
import DatasetService from "../../../../core/services/datasetService.js";
import DatasetList from "./datasetList.jsx";
import styles from "./header.scss";
var timeout;

class Title extends BaseComponent {
  render() {
    return (
      <div className="studio-title">
        <div className="inline-editable">{this.props.title}</div>
      </div>
    );
  }
}

class SearchBox extends BaseComponent {
  handelChange() {
    this.props.onUserInput(
      this.refs.searchInput.value
    );
    $("#studio-search-clear-btn").fadeIn(300);
  }

  handelChangeDelay() {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(this.handelChange, 300);
  }

  reset() {
    $(this.refs.searchInput).val("");
    $("#studio-search-clear-btn").fadeOut(300);
    this.props.onClose();
  }

  render() {
    return (
      <div className="studio-search">
        <input type="text"
               placeholder="Search Topic"
               ref="searchInput"
               onChange={this.handelChangeDelay}/>
        <i className="material-icons" id="studio-search-clear-btn" onClick={this.reset}>close</i>
      </div>
    );
  }
}

export default class Header extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      searchString: "",
      datasets: []
    }
  }

  reset() {
    this.setState({
      searchString: "",
      datasets: []
    });
  }

  onSearchValueChange(searchString) {
    var ss = searchString.trim();

    // reset paging for the new search
    this.pagination = {
      pageNumber: 1,
      pageSize: 15,
      isLastPage: false
    };

    if (ss === "") {
      this.setState({
        searchString: "",
        datasets: []
      });
      return;
    }

    DatasetService.getDataSetsByName(searchString, this.pagination, (response) => {
      this.pagination.isLastPage = response.data.length < this.pagination.pageSize;
      this.setState({
        searchString: ss,
        datasets: response.data
      });
    });
  }

  findDatasets() {

    if (this.pagination.isLastPage || this.state.searchString === "") return;

    var pagingOption = {
      pageNumber: ++this.pagination.pageNumber,
      pageSize: this.pagination.pageSize
    };

    DatasetService.getDataSetsByName(this.state.searchString, pagingOption, (response) => {
      this.pagination.isLastPage = response.data.length < this.pagination.pageSize;

      if (response.data.length > 0) {
        var concatedDatasets = this.state.datasets.concat(response.data);
        this.setState({
          datasets: concatedDatasets
        });
      }
    });
  }

  componentWillMount() {
    if (this.props.title === "") this.props.title = "TITLE";
  }

  render() {
    return (
      <div className="studio-header" id="studio-header">
        <Title title={this.props.title}/>
        {/*<SearchBox onUserInput={this.onSearchValueChange} onClose={this.reset}/>*/}
        <div className="studio-header-action">
          <i className="arrow arrows-square-up"/>
        </div>
        <DatasetList getNextPage={this.findDatasets} datasets={this.state.datasets}/>
      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/analytic-studio/editor/header/header.jsx